var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1912 2.95C27.185 1.05 24.627 0 21.9687 0C19.3103 0 16.6019 1.05 14.7461 2.95L2.95925 14.65C1.10345 16.5 0 19.05 0 21.85C0 24.5 1.05329 27.2 2.95925 29.05C4.8652 30.9 7.52351 32 10.1818 32C12.8401 32 15.5486 30.95 17.4044 29.05L29.0408 17.45C30.8966 15.6 32 12.9 32 10.25C32 7.6 31.047 4.95 29.1912 2.95ZM15.5486 27.05C14.094 28.5 12.1881 29.3 10.1818 29.3C8.17555 29.3 6.31975 28.5 4.81505 27.05C3.31034 25.6 2.65831 23.85 2.65831 21.85C2.65831 19.85 3.51097 18 4.96552 16.55L9.93103 11.6L20.6144 22.25L15.5486 27.05ZM27.185 15.45L22.2194 20.4L11.536 9.75L16.5016 4.8C17.9561 3.35 19.8621 2.55 21.8683 2.55C23.8746 2.55 25.7304 3.35 27.2351 4.8C28.7398 6.25 29.4922 8.15 29.4922 10.15C29.4922 12.15 28.6395 14.15 27.185 15.45Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillIcon);
export default __webpack_public_path__ + "static/media/pill-icon.bcd718b2.svg";
export { ForwardRef as ReactComponent };